import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DynamicDialogService } from '@volt/shared/components/dialogs/dynamic-dialog/dynamic-dialog.service';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FileParameter, TaskLocationClient, TaskLocationImportViewModel } from '../../../api.client';
import { OperatorUtils } from '../../../shared/utils/operator.utils';
import { ViewErrorStatusModalComponent } from '../view-error-status-modal/view-error-status-modal.component';
import {
  IServiceDeploymentLogStatus,
  ViewLogStatusModalComponent,
} from '../view-log-status-modal/view-log-status-modal.component';
import { environment } from '../../../../environments/environment';
import { BlobService } from '@volt/shared/services/blob.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'import-task-location.component',
  templateUrl: './import-task-location.component.html',
  providers: [MessageService],
})
export class ImportTaskLocationComponent implements OnInit {
  private serviceDeploymentRefId;
  private taskRefId;
  public working = false;
  public serviceDeploymentRefNumber;
  public taskRefNumber;
  public fieldGroupName: string;
  public accountId;
  public fileSize = 10000000;

  constructor(
    private _route: ActivatedRoute,
    private _taskLocationClient: TaskLocationClient,
    private readonly _dynamicDialogService: DynamicDialogService,
    private readonly _blobService: BlobService,
    private readonly _messageService: MessageService,
  ) {}

  ngOnInit(): void {
    combineLatest([
      this._route.queryParamMap,
      this._route.paramMap.pipe(filter(pm => pm.has('serviceDeploymentRefId') && pm.has('taskRefId')))
    ]).subscribe(([queryParams, params]: [ParamMap, ParamMap]) => {
      this.serviceDeploymentRefId = params.get('serviceDeploymentRefId');
      this.taskRefId = params.get('taskRefId');
      this.serviceDeploymentRefNumber = queryParams.get('serviceDeploymentRefNumber');
      this.taskRefNumber = queryParams.get('taskRefNumber');
      this.fieldGroupName = queryParams.get('fieldGroupName');
      this.accountId = queryParams.get('accountId');

    });
  }

  public uploadFile(files: File[]) {
    this.working = true;
    const file: FileParameter = {
      data: files[0],
      fileName: files[0].name,
    };

    this._taskLocationClient
      .uploadTaskLocation(this.serviceDeploymentRefNumber, this.accountId, this.taskRefNumber, file)
      .pipe(
        OperatorUtils.logAndRethrowError(() => {
          this.working = false;
        }),
      )
      .subscribe((taskLocationImport: TaskLocationImportViewModel) => {
        if (taskLocationImport.errorList && taskLocationImport.errorList.length > 0) {
          this._dynamicDialogService.open(ViewErrorStatusModalComponent, {
            data: { errorList: taskLocationImport.errorList },
            closeOnEscape: true,
          });
        } else {
          this._dynamicDialogService.open(ViewLogStatusModalComponent, {
            data: {
              status: 'Pending',
              serviceDeploymentStatusName: 'Task Location Status',
              serviceDeploymentReferenceNumber: 'Task Location Reference #',
              transactionId: taskLocationImport.transactionId,
              accountId: this.accountId,
              showImportTaskLocation: true,
              serviceDeploymentRefId: this.serviceDeploymentRefId,
              taskRefId: this.taskRefId,
            } as IServiceDeploymentLogStatus,
          });
        }
        this.working = false;
      });
  }

  downloadTemplate() {
    this._blobService
      .downloadBlobFromContainer(environment.uploadsSecureContainer, environment.eoc.taskLocationTemplate)
      .subscribe(
        _ => {},
        err => {
          console.error(err);

          this._messageService.add({
            severity: 'error',
            detail: 'Could not download file',
          });
        },
      );
  }
}
